// vivo 锁屏
export default {
  // 印尼语域名
  "id-v-ls.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: 3922785402,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 9760659739,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 9494907791,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4160387309,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 9767464449,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2847305636,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 越南语域名
  "vi-v-ls.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: 6594978951,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 6148717785,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 8179523367,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5553360028,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2655733949,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8151130441,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 泰语域名
  "th-v-ls.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: 7879667709,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 9569088042,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 3390231117,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1536295211,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 4324038831,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 8048092625,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 印地语域名
  "hi-v-ls.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: 8450986107,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 2704071453,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 4108847615,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 5085983409,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 2459820066,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 1146738395,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
  // 英语域名
  "en-v-ls.comfortweather.com": {
    "320x100": [
      {
        type: "ads",
        slot: 5798744940,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "top-banner",
      },
      {
        type: "ads",
        slot: 4056643581,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "bottom-banner",
      },
    ],
    "300x250": [
      {
        type: "ads",
        slot: 6394980043,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3384334599,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 3168712177,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
      {
        type: "ads",
        slot: 6916385490,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "any",
      },
    ],
  },
};
